import { IOption } from "../../../../../../../shared/contracts/IReportDataOptions";
import useWizardReportDataContext from "../../../../contexts/useWizardReportData.context";

/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/05/2025
 */
export default function useWizardReportPivotService() {

    const { groupByOptions, formatOptions } = useWizardReportDataContext();


    const getGroupByOptionsByDataType = (columnDataType?: string | null): IOption[] => {
        if (groupByOptions && columnDataType) {
            switch (columnDataType) {
                case 'NUMBER':
                    return groupByOptions.numberOptions || [];
                case 'VARCHAR2':
                case 'NVARCHAR2':
                    return groupByOptions.stringOptions || [];
                case 'DATE':
                    return groupByOptions.dateOptions || [];
                default:
                    console.warn('Unhandled columnDataType:', columnDataType);
                    debugger; // For debugging unexpected cases
                    return groupByOptions.stringOptions || [];
            }
        } else {
            return [];
        }
    }

    const getFormatOptionsByDataType = (columnDataType?: string | null): IOption[] => {
        if (formatOptions && columnDataType) {
            switch (columnDataType) {
                case 'NUMBER':
                    return formatOptions.numberOptions || [];
                case 'VARCHAR2':
                case 'NVARCHAR2':
                    return formatOptions.stringOptions || [];
                case 'DATE':
                    return formatOptions.dateOptions || [];
                default:
                    console.warn('Unhandled columnDataType:', columnDataType);
                    debugger; // For debugging unexpected cases
                    return formatOptions.stringOptions || [];
            }
        } else {
            return [];
        }
    }

    // ---
    return {
        getGroupByOptionsByDataType,
        getFormatOptionsByDataType
    }
}